import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Row, Col, Card, Spinner, Image, Button, Carousel, Alert, Accordion } from 'react-bootstrap';
import { LoginManager } from '../core/login-manager';
import { DataManager } from '../core/data-manager';
import { ApiManager } from '../core/api-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import andreaCavalli from '../config/assets/Andrea-Cavalli.png';
import ermesBonaldo from '../config/assets/Ermes-Bonaldo.png';
import massimoDeNoni from '../config/assets/Massimo-De-Noni.png';
import tommasoBosco from '../config/assets/Tommaso-Bosco.png';
import mattiaValenta from '../config/assets/Mattia-Valenta.png';
import enzoPigozzi from '../config/assets/Enzo-Pigozzi.png';
import gianlucaSiviero from '../config/assets/Gianluca-Siviero.png';


const SIGLA_TO_CAPITOLO = {
    AA: 'Accessori per Chiavi', AC: 'Accessori per Chiavi', PC: 'Accessori per Chiavi',
    AE: 'Utensileria Elettrica', ED: 'Utensileria Elettrica', EU: 'Utensileria Elettrica',
    MG: 'Utensileria Elettrica', PM: 'Utensileria Elettrica', PO: 'Utensileria Elettrica',
    PU: 'Utensileria Elettrica', RE: 'Utensileria Elettrica',
    AM: 'Utensileria Manuale', AT: 'Utensileria Manuale', BC: 'Utensileria Manuale',
    CA: 'Utensileria Manuale', CL: 'Utensileria Manuale', CM: 'Utensileria Manuale',
    DE: 'Utensileria Manuale', FM: 'Utensileria Manuale', FP: 'Utensileria Manuale',
    LS: 'Utensileria Manuale', MA: 'Utensileria Manuale', MC: 'Utensileria Manuale',
    PS: 'Utensileria Manuale', RL: 'Utensileria Manuale', TE: 'Utensileria Manuale',
    UC: 'Utensileria Manuale', UM: 'Utensileria Manuale', UP: 'Utensileria Manuale',
    AP: 'Igiene e Difesa', CH: 'Igiene e Difesa',
    AW: 'Scarpe ed Abbigliamento', SC: 'Scarpe ed Abbigliamento',
    AS: 'Chiavi Originali e Serrature', CF: 'Chiavi Originali e Serrature',
    CI: 'Chiavi Originali e Serrature', CO: 'Chiavi Originali e Serrature',
    LM: 'Chiavi Originali e Serrature', LP: 'Chiavi Originali e Serrature',
    SE: 'Chiavi Originali e Serrature',
    BA: 'Elettronica e Radiocomandi', ME: 'Elettronica e Radiocomandi',
    QA: 'Elettronica e Radiocomandi', RC: 'Elettronica e Radiocomandi',
    MD: 'Duplicazione', RM: 'Duplicazione',
};

const CAPITOLI_ORDER = [
    'Accessori per Chiavi',
    'Utensileria Elettrica',
    'Utensileria Manuale',
    'Igiene e Difesa',
    'Scarpe ed Abbigliamento',
    'Chiavi Originali e Serrature',
    'Elettronica e Radiocomandi',
    'Duplicazione',
];


export default function Dashboard() {

    const navigate = useNavigate();
    const userInfo = LoginManager.getUserInfo();
    const [errors, setErrors] = useState('');
    const [data, setData] = useState(null);
    const [items, setItems] = useState(null);
    const [promo, setPromo] = useState(null);
    const [avip, setAvip] = useState(null);
    const [waitingOrders, setWaitingOrders] = useState(null);


    async function init() {
        var resp = await DataManager.getItem('user_group', userInfo.idUserGroup)
        if (resp.success === 1) {
            setData(resp.body[0])
        }
        else {
            setErrors(resp.message)
        }
    }

    async function getNewProducts() {
        var resp = await ApiManager.sendAuthenticatedRequest('/custom/get_new_products', {
            limit: 200,
            offset: 0
        })
        if (resp.success === 1) {
            setItems(resp.body)
            console.warn("nuovi prodotti", resp.body)
        }
    }

    //promo
    async function getPromo() {
        var constraints = [
            {
                fieldName: 'sku',
                type: 'start',
                value: 'PREW'
            },
            {
                fieldName: 'outOfStock',
                type: 'different_from_value',
                value: 'E'
            }
        ]
        var resp = await DataManager.searchItems('gyv_item', 1, 100, { field: 'id', order: 'DESC' }, '', [], constraints)
        if (resp.success === 1) {
            setPromo(resp.body)
            console.warn("promo", resp.body)
        }
    }

    // avvisi il portale
    async function getAvvisi() {
        var constraints = [
            {
                fieldName: 'sku',
                type: 'start',
                value: 'AVIP'
            },
            {
                fieldName: 'outOfStock',
                type: 'different_from_value',
                value: 'E'
            }
        ]
        var resp = await DataManager.searchItems('gyv_item', 1, 100, { field: 'id', order: 'DESC' }, '', [], constraints)
        if (resp.success === 1) {
            setAvip(resp.body)
            console.warn("avip", resp.body)
        }
    }

    async function getWaitingOrder() {
        if (userInfo.level !== 2) {
            var constraints = [
                {
                    fieldName: 'status',
                    type: 'value',
                    value: '5_WAITING'
                }
            ]
            var resp = await DataManager.searchItems('gyv_order', 1, 100, { field: 'id', order: 'DESC' }, '', [], constraints)
            if (resp.success === 1) {
                setWaitingOrders(resp.body)
                console.warn("ordini in attesa", resp.body)
            }
        }
    }

    useEffect(() => {
        init()
        getNewProducts()
        getPromo()
        getAvvisi()
        getWaitingOrder()
    }, []);


    async function openItem(item) {
        var constraints = [
            {
                fieldName: 'sku',
                type: 'value',
                value: item.sku
            }
        ]
        var resp = await DataManager.searchItems('gyv_item', 1, 100, { field: 'id', order: 'ASC' }, '', [], constraints)
        if (resp.success === 1 && resp.body.length) {
            setItems(resp.body)
            localStorage.setItem('prevSearch', '/');
            navigate('/page/ItemPreview?id=' + resp.body[0].id)
        }
    }






    return (
        <>
            <p className=''>
                Benvenuto nel portale {userInfo.level === 2 ? 'clienti' : 'agenti'}!
            </p>

            <Card>
                <Card.Body>
                    <Row className='align-items-center'>
                        <Col xs={12} lg={4}>
                            <p>
                                <FontAwesomeIcon icon="circle-check" size={'lg'} color='green' className='me-1' /> Continue novità di prodotto
                            </p>
                            <p>
                                <FontAwesomeIcon icon="circle-check" size={'lg'} color='green' className='me-1' /> Ricerche anche con codici vecchi
                            </p>
                            <p>
                                <FontAwesomeIcon icon="circle-check" size={'lg'} color='green' className='me-1' /> Calcolo promozioni automatico
                            </p>
                            <p>
                                <FontAwesomeIcon icon="circle-check" size={'lg'} color='green' className='me-1' /> I Tuoi prodotti personalizzati
                            </p>
                            <p>
                                <FontAwesomeIcon icon="circle-check" size={'lg'} color='green' className='me-1' /> Sempre più immagini e video
                            </p>
                            <p className='mb-0'>
                                <FontAwesomeIcon icon="circle-check" size={'lg'} color='green' className='me-1' /> <span className='text-danger'>IP</span>.TRIVEK.IT     <span className='text-danger'>I</span>l <span className='text-danger'>P</span>ortale che serve
                            </p>
                        </Col>
                        <Col xs={12} lg={3}>
                            {data ? (
                                <>
                                    {(() => {
                                        switch (data.id) {
                                            case 1: return (
                                                <Image src={ermesBonaldo} roundedCircle width={150} height={'auto'} className='mb-4' />
                                            );
                                            case 4: return (
                                                <Image src={massimoDeNoni} roundedCircle width={150} height={'auto'} className='mb-4' />
                                            );
                                            case 23: return (
                                                <Image src={tommasoBosco} roundedCircle width={150} height={'auto'} className='mb-4' />
                                            );
                                            case 24: return (
                                                <Image src={andreaCavalli} roundedCircle width={150} height={'auto'} className='mb-4' />
                                            );
                                            case 26: return (
                                                <Image src={enzoPigozzi} roundedCircle width={150} height={'auto'} className='mb-4' />
                                            );
                                            case 29: return (
                                                <Image src={gianlucaSiviero} roundedCircle width={150} height={'auto'} className='mb-4' />
                                            );
                                            default: return (
                                                <Image src={mattiaValenta} roundedCircle width={150} height={'auto'} className='mb-4' />
                                            );
                                        }
                                    })()}
                                </>
                            ) : (
                                <Spinner />
                            )}

                        </Col>
                        <Col xs={12} lg={5}>
                            {data ? (
                                <p>Il tuo agente di riferimento è: <b>{data.name}</b><br />
                                    scrivigli all'indirizzo: <b>{data.email}</b><a href={`mailto:${data.email}`} className='ms-2 text-decoration-none'>
                                        <FontAwesomeIcon icon='envelope' className='text-primary' />
                                    </a><br />
                                    o contattalo al numero: <b>{data.phone}</b><a href={`tel:+39${data.phone.replace(/\D/g, '')}`} className='ms-2 text-decoration-none'>
                                        <FontAwesomeIcon icon='phone' className='text-primary' />
                                    </a><a href={`https://wa.me/39${data.phone.replace(/\D/g, '')}`} target='_blank' rel='noreferrer' className='ms-2 text-decoration-none'>
                                        <FontAwesomeIcon icon='comment-dots' className='text-success' />
                                    </a></p>
                            ) : null}
                            <div className='d-flex align-items-center'>
                                <Link to="/page/ContactEmail">
                                    <Button variant='success'>
                                        <FontAwesomeIcon icon="envelope" className='me-2' />Contatti aziendali
                                    </Button>
                                </Link>
                                <span className='ms-3'>
                                    <a href='mailto:info@trivek.it' className='me-3 text-decoration-none'>
                                        <FontAwesomeIcon icon='envelope' className='text-primary' />
                                    </a>
                                    <a href='tel:+390438784348' className='me-3 text-decoration-none'>
                                        <FontAwesomeIcon icon='phone' className='text-primary' />
                                    </a>
                                    <a href='https://wa.me/393371292508' target='_blank' rel='noreferrer' className='text-decoration-none'>
                                        <FontAwesomeIcon icon='comment-dots' className='text-success' />
                                    </a>
                                </span>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>


            {waitingOrders && waitingOrders.length ? (
                <Card className='mt-4'>
                    <Card.Body>
                        <h3><b>Ci sono {waitingOrders.length} ordini in attesa</b></h3>
                        {waitingOrders.map((item, i) => {
                            return (
                                <li key={i}>{item.customer}</li>
                            )
                        })}
                        <Link to="/page/OrderToAccept">
                            <Button className='mt-4'>Vai agli ordini</Button>
                        </Link>
                    </Card.Body>
                </Card>
            ) : (
                <></>
            )}


            {(promo && promo.length) || (avip && avip.length) ? (
                <>
                    <h1 className='mt-4 text-danger'><i><b>Promozioni e Avvisi</b></i></h1>
                    <Carousel data-bs-theme="dark">
                        {promo && promo.length > 0 && promo.filter(item => item.image !== 'Default.jpg').map((item, i) => {
                            return (
                                <Carousel.Item key={'promo-' + i}>
                                    <Row className='align-items-center bg-white'>
                                        <Col xs={12} md={2}></Col>
                                        <Col xs={12} md={5} className='p-3'>
                                            <h4>{item.name}</h4>
                                            <p dangerouslySetInnerHTML={{ __html: item.description }} />
                                            <Button onClick={() => openItem(item)}>Porta nel mio ordine</Button>
                                            {item && item.linkSchede ? (
                                                <a href={"https://www.trivek.it/Engine/Promo/" + item.linkSchede} target="_blank">
                                                    <Button className='ms-1' variant='outline-primary'>Dettagli</Button>
                                                </a>
                                            ) : null}
                                            <p className='text-primary'>{item.notes ? item.notes.replace(/£/g, ' ') : ''}</p>
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <Image role='button' onClick={() => openItem(item)} src={'https://www.trivek.it/Engine/Img/' + item.image} width={'100%'} />
                                        </Col>
                                        <Col xs={12} md={2}></Col>
                                    </Row>
                                </Carousel.Item>
                            )
                        })}
                        {avip && avip.length > 0 && avip.filter(item => item.image !== 'Default.jpg').map((item, i) => {
                            return (
                                <Carousel.Item key={'avip-' + i}>
                                    <Row className='align-items-center bg-white'>
                                        <Col xs={12} md={2}></Col>
                                        <Col xs={12} md={5} className='p-3'>
                                            <h4>{item.name}</h4>
                                            <p dangerouslySetInnerHTML={{ __html: item.description }} />
                                            {item && item.linkSchede ? (
                                                <a href={"https://www.trivek.it/Engine/Promo/" + item.linkSchede} target="_blank">
                                                    <Button className='ms-1' variant='outline-primary'>Dettagli</Button>
                                                </a>
                                            ) : null}
                                            <p className='text-primary'>{item.notes ? item.notes.replace(/£/g, ' ') : ''}</p>
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <Image src={'https://www.trivek.it/Engine/Img/' + item.image} width={'100%'} />
                                        </Col>
                                        <Col xs={12} md={2}></Col>
                                    </Row>
                                </Carousel.Item>
                            )
                        })}
                    </Carousel>
                </>
            ) : (
                <></>
            )}


            {items && items.length ? (() => {
                const visible = items.filter(it => it.image !== 'Default.jpg');
                const chiave = visible.filter(it => it.isChiave === 1 || it.isChiave === '1');
                const others = visible.filter(it => !(it.isChiave === 1 || it.isChiave === '1'));
                const grouped = {};
                CAPITOLI_ORDER.forEach(c => { grouped[c] = []; });
                const altro = [];
                others.forEach(it => {
                    const sigla = (it.sku || '').substring(0, 2).toUpperCase();
                    const cap = SIGLA_TO_CAPITOLO[sigla];
                    if (cap && grouped[cap]) grouped[cap].push(it);
                    else altro.push(it);
                });

                const renderGrid = (list) => (
                    list.length ? (
                        <Row className='align-items-center'>
                            {list.map((item, i) => (
                                <Col key={i} xs={12} md={6} lg={3}>
                                    <Card className='mb-3'>
                                        <Card.Body>
                                            <Image role='button' onClick={() => openItem(item)} src={'https://www.trivek.it/Engine/Img/' + item.image} width={'100%'} />
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    ) : (
                        <p className='text-muted mb-0'>Nessun articolo in questa categoria.</p>
                    )
                );

                return (
                    <>
                        <h1 className='mt-4 text-danger'><i><b>Scopri le novità!</b></i></h1>
                        <Accordion defaultActiveKey="chiave" className='mb-4'>
                            <Accordion.Item eventKey="chiave">
                                <Accordion.Header>Chiavi&nbsp;<span className='text-muted'>({chiave.length})</span></Accordion.Header>
                                <Accordion.Body>{renderGrid(chiave)}</Accordion.Body>
                            </Accordion.Item>
                            {CAPITOLI_ORDER.filter((cap) => grouped[cap].length).map((cap, idx) => (
                                <Accordion.Item key={cap} eventKey={'cap-' + idx}>
                                    <Accordion.Header>{cap}&nbsp;<span className='text-muted'>({grouped[cap].length})</span></Accordion.Header>
                                    <Accordion.Body>{renderGrid(grouped[cap])}</Accordion.Body>
                                </Accordion.Item>
                            ))}
                            {/* {altro.length ? (
                                <Accordion.Item eventKey="altro">
                                    <Accordion.Header>Altro&nbsp;<span className='text-muted'>({altro.length})</span></Accordion.Header>
                                    <Accordion.Body>{renderGrid(altro)}</Accordion.Body>
                                </Accordion.Item>
                            ) : null} */}
                        </Accordion>
                    </>
                );
            })() : (
                <></>
            )}

            <div className='text-center mt-4 mb-4'>
                <Button variant='outline-secondary' onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                    <FontAwesomeIcon icon="chevron-up" className='me-1' /> Torna su
                </Button>
            </div>
        </>
    )
};